var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.fetching)?_c('b-spinner',{attrs:{"variant":"primary"}}):_c('ZoneServiceVersion',{attrs:{"is-new":false,"last-version":_vm.version,"service":_vm.version.service_class,"zones":_vm.zones}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }